import { Button } from 'src/components/atoms';
import {
  RoutingRuleFooterRight,
  RoutingRuleFooterStyled,
} from './RoutingRuleFooter.styles';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { FormInput } from '../FormInput';
import { DefaultOption } from '../DropdownSelect';
import { FormInputVariant } from 'src/types';
import { RoutingRuleType } from 'src/graphql';

interface Props {
  rule: RoutingRuleType;
  dropdownOptions: DefaultOption[];
  duplicateRule: () => void;
  deleteRule: () => void;
  saveRule: () => void;
  disableRule: () => void;
  enableRule: () => void;
  tabIndex?: number;
}

export const RoutingRuleFooter = ({
  rule,
  dropdownOptions,
  duplicateRule,
  deleteRule,
  saveRule,
  disableRule,
  enableRule,
  tabIndex,
}: Props) => (
  <RoutingRuleFooterStyled>
    <FormInput
      variant={FormInputVariant.DROPDOWN}
      options={dropdownOptions}
      onChange={(value) => {
        switch ((value as DefaultOption).value) {
          case 'duplicate':
            duplicateRule();
            break;

          case 'delete':
            deleteRule();
            break;
          default:
            break;
        }
      }}
      routing
      buttonText="More"
      menuPlacement="top"
      width="140px"
      data-testid="rule-options-select"
      tabIndex={tabIndex}
      controlShouldRenderValue={false}
    />
    <RoutingRuleFooterRight>
      <Button
        size="medium"
        variant="secondary"
        width="140px"
        onClick={saveRule}
        data-testid="save-rule"
        tabIndex={tabIndex}
      >
        Save
      </Button>
      {!rule.disabled ? (
        <Button
          variant="primary"
          size="medium"
          width="150px"
          onClick={disableRule}
          data-testid={`routing-rule-button-pause-rule-${rule.id}`}
          tabIndex={tabIndex}
        >
          <StyledIconInButton
            size="medium"
            position="left"
            className="uil uil-pause"
          />
          Pause rule
        </Button>
      ) : (
        <Button
          variant="primary"
          size="medium"
          width="150px"
          data-testid={`routing-rule-button-activate-rule-${rule.id}`}
          onClick={enableRule}
          tabIndex={tabIndex}
        >
          <StyledIconInButton
            size="medium"
            position="left"
            className="uil uil-play"
          />
          Activate rule
        </Button>
      )}
    </RoutingRuleFooterRight>
  </RoutingRuleFooterStyled>
);
